import { getUsuario } from "../auth"
import API from "./index"

class SubgrupoProdutoService {
  constructor() {
    this.path = `api/subgrupo`
  }

  async findAll({ page = 0, size = 10, situacao, descricao, grupoId }) {
    page = Math.max(page - 1, 0)

    try {
      const response = await API.get(this.path, {
        params: {
          grupoId,
          descricao,
          situacao,
          page,
          size,
        },
      })

      if (response.status === 200) {
        const { data } = response
        this.records = Array.isArray(data.content) ? data.content : []
        this.total = data.totalElements || 0
        this.totalPage = data.totalPages || 0
        this.page = data.pageable.pageNumber + 1
        return data
      }
    } catch (error) {
      console.error("Error fetching data:", error)
      throw new Error("Failed to load resource")
    }
  }

  find() {
    return API.get(`${this.path}`)
  }
  findById(id) {
    return API.get(`${this.path}/${id}`)
  }

  async save(record) {
    if (record.id) {
      return await API.put(`${this.path}/${record.id}`, record).then(
        ({ ...args }) => ({ created: false, ...args })
      )
    }

    let usuario = getUsuario()
    usuario = usuario ? usuario.nome : null
    return await API.post(this.path, { ...record, usuario }).then(
      ({ ...args }) => ({
        created: true,
        ...args,
      })
    )
  }

  async alteraSituacao({ id, situacao }) {
    return await API.put(`${this.path}/${id}/situacao`, { situacao }).then(
      ({ ...args }) => ({ created: false, ...args })
    )
  }

  remove(id) {
    if (!id) {
      throw new Error("ID cannot be null")
    }
    return API.delete(`${this.path}/${id}`)
  }

  async saveClasse(idSubgrupo, record) {
    if (record.id) {
      return await API.put(
        `${this.path}/${idSubgrupo}/classe/${record.id}`,
        record
      ).then(({ ...args }) => ({ created: false, ...args }))
    }

    return API.post(`${this.path}/${idSubgrupo}/classe`, record).then(
      ({ ...args }) => ({
        created: true,
        ...args,
      })
    )
  }
  async alteraSituacaoClasse(idSubgrupo, { id, situacao }) {
    return await API.put(`${this.path}/${idSubgrupo}/classe/${id}/situacao`, {
      situacao,
    }).then(({ ...args }) => ({ created: false, ...args }))
  }

  async mover(subgrupoOrigem, subgrupoDestino) {
    return await API.put(
      `${this.path}/${subgrupoOrigem.id}/mover/${subgrupoDestino.id}`
    ).then(({ ...args }) => ({ created: false, ...args }))
  }

  buscaQuantidadeProdutos(record) {
    return API.get(`${this.path}/${record.id}/totalizador`)
  }

  removeClasse(idSubgrupo, id) {
    if (!id) {
      throw new Error("ID cannot be null")
    }
    return API.delete(`${this.path}/${idSubgrupo}/classe/${id}`)
  }
}

export default SubgrupoProdutoService
